import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, Star } from 'lucide-react';

function IncludesList({ items }) {
  return (
    <ul className="space-y-1.5 md:space-y-2 mb-4 md:mb-6">
      {items.map(function(item) {
        return (
          <li key={item} className="flex items-start gap-1.5 md:gap-2 text-xs md:text-sm">
            <svg className="w-3.5 h-3.5 md:w-4 md:h-4 mt-0.5 flex-shrink-0 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
            <span className="text-gray-600">{item}</span>
          </li>
        );
      })}
    </ul>
  );
}

function SinglePack({ name, persons, price, items, featured, idx }) {
  return (
    <div className={"relative bg-white text-gray-900 shadow-lg rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl flex flex-col"} data-testid={"pack-card-" + idx}>
      {featured && (
        <div className="absolute top-1.5 right-1.5 md:top-2 md:right-2 px-1.5 py-0.5 md:px-2 bg-orange-500 text-white rounded-full text-[8px] md:text-xs font-bold uppercase tracking-wider flex items-center gap-0.5 md:gap-1 z-10">
          <Star className="w-2 h-2 md:w-3 md:h-3" /> Populaire
        </div>
      )}
      <div className="p-3 md:p-6 flex flex-col flex-1">
        <h3 className={"text-sm md:text-lg font-bold mb-0.5 md:mb-1 text-gray-900 " + (featured ? "pr-14 md:pr-20" : "")}>{name}</h3>
        <div className="flex items-center gap-1 text-xs md:text-sm mb-2 md:mb-4 text-gray-500">
          <Users className="w-3 h-3 md:w-4 md:h-4" />{persons}
        </div>
        <div className="mb-3 md:mb-5">
          <span className="text-base md:text-2xl font-black text-orange-500">A partir de {price}</span>
        </div>
        <div className="flex-1">
          <IncludesList items={items} />
        </div>
        <Link to="/devis" className="w-full flex items-center justify-center gap-1 md:gap-2 px-3 md:px-5 py-2 md:py-3 rounded-xl font-semibold text-xs md:text-sm transition-colors bg-orange-500 text-white hover:bg-orange-600 mt-auto">
          Demander un devis <ArrowRight className="w-3 h-3 md:w-4 md:h-4" />
        </Link>
      </div>
    </div>
  );
}

function PacksSection() {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-br from-gray-800 via-gray-900 to-gray-800" data-testid="packs-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-14">
          <span className="inline-block px-4 py-2 bg-orange-500 text-white text-sm font-bold rounded-full mb-4">LE PLUS DEMANDE</span>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4">Packs Tout Inclus</h2>
          <p className="text-sm md:text-lg text-gray-300 max-w-2xl mx-auto">Simplifiez-vous la vie avec nos formules completes</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          <SinglePack idx={1} name="Pack Essentiel" persons="32 personnes" price="390&#8364;" items={["Barnum 4x8m", "32 Chaises", "6 Tables rectangles", "Eclairage offert"]} featured={false} />
          <SinglePack idx={2} name="Pack Fiesta" persons="50 personnes" price="590&#8364;" items={["Barnum 5x10m", "50 Chaises", "8 Tables rectangles", "Eclairage guinguette", "Sono et jeux de lumieres"]} featured={true} />
          <SinglePack idx={3} name="Pack Reception" persons="72 personnes" price="790&#8364;" items={["Barnum 6x12m", "72 Chaises", "12 Tables rectangles", "Vaisselle au choix", "Eclairage + Sono offertes"]} featured={true} />
          <SinglePack idx={4} name="Pack Evenement" persons="96 personnes" price="1 490&#8364;" items={["Barnum 8x12m", "Plancher bois", "96 Chaises", "16 Tables rectangles", "Eclairage + Chauffage"]} featured={false} />
          <SinglePack idx={5} name="Pack Premium" persons="128 personnes" price="2 290&#8364;" items={["Barnum 8x16m", "Plancher bois", "128 Chaises", "21 Tables rectangles", "Vaisselle", "Eclairage + Chauffage", "Pack Sono"]} featured={false} />
          <SinglePack idx={6} name="Pack Mariage" persons="100 personnes" price="2 390&#8364;" items={["Barnum 8x16m", "Plancher bois", "100 Chaises ceremonie", "10 Tables rondes", "Eclairage Guinguette"]} featured={false} />
        </div>
        <div className="text-center mt-12">
          <Link to="/catalogue/pack-tout-inclus" className="inline-flex items-center gap-2 px-8 py-4 bg-orange-500 text-white font-semibold rounded-full hover:bg-orange-600 transition-all shadow-lg" data-testid="packs-see-all">
            Voir tous les packs <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default PacksSection;
